module.exports = __webpack_public_path__ + "img/return-icon-white.9956c252.svg";